import { connect } from 'react-redux';
import { getCurrentUser, getCanEnableToggleMatureContent, getTierСount } from '../../../../publicSession/selectors';
import { toggleMature, toggleTheme } from '../../../../publicSession/actions';
import { userLogoutButtonClicked } from '../../../redux/actions';
const mapStateToProps = (state)=>({
        currentUser: getCurrentUser(state),
        canEnableMatureContent: getCanEnableToggleMatureContent(state),
        hasSubscriptions: getTierСount(state) > 0
    });
const mapDispatchToProps = {
    toggleTheme,
    toggleMature,
    onUserLogoutButtonClicked: userLogoutButtonClicked
};
export default connect(mapStateToProps, mapDispatchToProps);
